<template>
  <div class="timetable-bottom-message" :class="[{ 'is-important': isImportant }]">
    <b-alert show
             :variant="variant"
             class="rounded-0"
    >
      <b-row align-v="center" class="alert-content">
        <b-col cols="8"
               class="p-0"
               :class="'design-' + design"
        >
          <div class="small" :class="variant">
            <slot v-if="title" name="title">
              <span class="font-weight-bold text-left float-left pb-1">{{ title }}</span>
              <br />
            </slot>
            <slot name="description">
              <span class="text-left float-left">
                {{ description }}
                <b-button v-if="design === 2"
                          variant="transparent"
                          class="reset-button"
                          @click="$emit('submit-click')"
                >
                  {{ submit }}
                </b-button>
                <slot name="second-action" />
              </span>
            </slot>
          </div>
        </b-col>
        <b-col v-if="design !== 2" class="p-0 text-right">
          <div>
            <slot class="submit">
              <b-button
                type="button"
                class="btn custom-submit"
                pill
                data-cy="notch-alert-button"
                size="sm"
                :class="[filledButton ? 'btn-' + variant : 'btn-outline-' + variant]"
                @click="$emit('submit-click')"
              >
                {{ submit }}
              </b-button>
            </slot>
          </div>
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'NotchAlert',
  props: {
    title: {
      type: String,
      default: '',
    },

    description: {
      type: String,
      default: '',
    },

    submit: {
      type: String,
      default: '',
    },

    action: {
      type: String,
      default: '',
    },

    variant: {
      type: String,
      default: 'primary',
    },

    filledButton: {
      type: Boolean,
      default: true,
    },

    isImportant: {
      type: Boolean,
      default: false,
    },

    design: {
      type: Number,
      default: 1,
    },
  },

  emits: ['submit-click'],
}
</script>

<style scoped lang="scss">
.timetable-bottom-message {
  bottom: 0; // for old browsers where `env` is not supported
  bottom: env(safe-area-inset-bottom) !important;

  .alert-content {
    max-width: 714px;
    margin: 0 auto;
  }

  > .alert {
    margin: 0;
    padding: 17px 7px 28px;
    padding-bottom: 70px;
  }

  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 6;
  }
}

.is-important {
  z-index: 1029 !important;
}

.btn-outline-primary.custom-submit:focus,
.btn-outline-primary.custom-submit:focus:active {
  box-shadow: none !important;
}

.text-underline {
  text-decoration: underline;
  cursor: pointer;
}

.design-2 {
  max-width: 100% !important;
  display: block;
  flex: 100%;
  text-align: left;
}

.reset-button {
  text-decoration: underline !important;
  color: inherit !important;
  font-size: pxtorem(14);
}
</style>
